let recaptcha_site_key = $("meta[name='recaptcha-site-key']").attr("content");
let page_elements;
let response_data;
let change_number_status = 0;
let timerOn = true;
let leadSource = null;
window.asapHome = config.route.home+ '/asap-learning';
window.onload = function() {
    let sessionValue = sessionStorage.getItem("asapCookie");
    if (sessionValue) {
        leadSource = "ASAP";
    }
}
//redirection//
let params = new URLSearchParams(window.location.search);
let redirect_url = params.get("next_url");
if (redirect_url) {
    let signupLinkElement = $(".js-show-sign-up");
    let singInWithSocialElements = $(".ui-sign-with-list");
    let currentSignupHref = signupLinkElement.attr("href");
    signupLinkElement.attr(
        "href",
        currentSignupHref + "?next_url=" + redirect_url
    );
    let forgotPasswordElement = $(".ui-forgot-password");
    let currentForgotHref = forgotPasswordElement.attr("href");
    forgotPasswordElement.attr(
        "href",
        currentForgotHref + "?next_url=" + redirect_url
    );
    let forgotPasswordLoginElement = $(".js-show-login");
    let currentForgotLoginHref = forgotPasswordLoginElement.attr("href");
    forgotPasswordLoginElement.attr(
        "href",
        currentForgotLoginHref + "?next_url=" + redirect_url
    );
    let socialLoginFbBtn = $("#social-media-login-facebook-btn");
    let socialLoginGoogleBtn = $("#social-media-login-google-btn");
    let socialLoginLinkedInBtn = $("#social-media-login-linkedin-btn");
    let currentFbHref = socialLoginFbBtn.attr("href");
    let currentGoogleHref = socialLoginGoogleBtn.attr("href");
    let currentLinkedInHref = socialLoginLinkedInBtn.attr("href");

    socialLoginFbBtn.attr("href", currentFbHref + "?next_url=" + redirect_url);
    socialLoginGoogleBtn.attr(
        "href",
        currentGoogleHref + "?next_url=" + redirect_url
    );
    socialLoginLinkedInBtn.attr(
        "href",
        currentLinkedInHref + "?next_url=" + redirect_url
    );
    singInWithSocialElements.children().each(function (index, element) {
        let currentHref=$(element).find("a").attr("href")
        $(element).find("a").attr("href",currentHref+"?next_url="+redirect_url)
    })

}
//redirection//

$(function() {
    // remove required message in validation
    $.validator.messages.required = "";

    // new validation - either email or mobile is required
    $.validator.addMethod(
        "email_or_mobile",
        function(value, element) {
            return (
                /^\d{8,11}$/.test(value) || //Indian Mobile No. Lenth 10
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    value
                )
            ); //email
        },
        "Please enter valid email or mobile"
    );

    // Trim white space of input
    $.each($.validator.methods, function(key, value) {
        $.validator.methods[key] = function() {
            if (arguments.length > 0) {
                var el = $(arguments[1]);
                el.val($.trim(el.val()));
            }

            return value.apply(this, arguments);
        };
    });

    page_elements = {
        signup_form: {
            form: $("#register-form"),
            phone: $("#register-phone"),
            email: $("#register-email"),
        },
        email_form: {
            form: $("#register-email-form"),
        },
        verify_otp: {
            form: $("#verify-otp"),
            otp: $('#verify-otp input[name="OTP[]"]'),
            common_error: $("#verify-otp .js-common-error")
        },
        resend_otp: $(".js-resend-otp"),
        login_form: {
            form: $("#login-form"),
            username: $("#login-username"),
            alert: $("#password-reset-alert")
        },
        login_password_form: {
            form: $("#login-password-form"),
            username: $("#login-password-username"),
            password: $("#login-password-password"),
            request_otp: $("#js-show-request-otp"),
            common_error: $("#login-password-form .js-common-error")
        },
        fogot_passwod: {
            form: $("#fogot-passwod-form"),
            username: $("#forgot-password-username")
        },
        reset_passwod: {
            form: $("#reset-password-form"),
            password: $("#reset-confirm-password")
        },
        password_eye: $(".js-password-toggle-btn"),
        otp_input_wrap: $(".js-otp-inputs-wrap"),
        page_change: $(".js-page-switch"),
        email_or_mobile: $(".js-email-or-phone"),
        verify_storage: "verify"
    };

    // contry code select init
    countryCodeInput(page_elements.signup_form.phone);
    countryCodeInput(page_elements.login_form.username);
    countryCodeInput(page_elements.login_password_form.username);
    countryCodeInput(page_elements.fogot_passwod.username);

    CommonMethods.removeFromStorage(page_elements.verify_storage);

    initFormEvents();

    initValidation(); // validation initalize
    page_elements.signup_form.form.not(":disabled").on("submit", createStudent);
    page_elements.email_form.form.not(":disabled").on("submit", createStudentEmail);
    page_elements.verify_otp.form.not(":disabled").on("submit", verifyOTP);
    page_elements.resend_otp.not(":disabled").on("click", resendOTP);
    page_elements.login_form.form
        .not(":disabled")
        .on("submit", loginUsernameCollect);
    page_elements.login_password_form.form
        .not(":disabled")
        .on("submit", loginPassword);
    page_elements.login_password_form.request_otp
        .not(":disabled")
        .on("click", requestOTP);
    page_elements.fogot_passwod.form
        .not(":disabled")
        .on("submit", initiatePasswordReset);
    page_elements.reset_passwod.form
        .not(":disabled")
        .on("submit", resetPassword);
});

/**
 * Initialise all input events
 *
 * @author Nishal K.R <nishal@webandcrafts.com>
 *
 * @param JSON page_elements - page element list
 *
 * @return void
 */
function initFormEvents() {
    // switch email and mobile input
    page_elements.email_or_mobile.on("keyup", function() {
        let $this = $(this);
        if ($.isNumeric($this.val())) {
            // $this.attr('type', 'text');
            $this.parents(".form-group").addClass("ui-isd-code-show");
        } else {
            // $this.attr('type', 'email');
            $this.parents(".form-group").removeClass("ui-isd-code-show");
        }
    });
    page_elements.email_or_mobile.on("blur", function() {
        let $this = $(this);
        if ($.isNumeric($this.val())) {
            $this.attr("type", "text");
        } else {
            $this.attr("type", "email");
        }
    });

    // switch password with text : password eye
    page_elements.password_eye.on("click", function() {
        let inpPass = $(this)
            .parents(".js-password-wrap")
            .find("input");
        inpPass.attr("type") == "password"
            ? inpPass.attr("type", "text")
            : inpPass.attr("type", "password");
    });

    // OTP input wrap
    page_elements.otp_input_wrap.each(function() {
        let that = $(this);
        $(this)
            .find("input")
            .each(function() {
                let otpInput = that.find("input"),
                    submit = that.parents("form").find('button[type="submit"]');
                $(this).attr("maxlength", 1);
                $(this).on("keypress", function(e) {
                    if (e.keyCode !== 17) {
                        e.preventDefault();
                        $(this).val(e.key);
                    }
                });
                $(this).on("keyup", function (e) {
                    // let parent = $($(this).parent());
                    // (e.keyCode >= 65 && e.keyCode <= 90) ||
                    if (e.keyCode === 8 || e.keyCode === 37) {
                        let prev = that.find("input").eq($(this).index() - 1);
                        if (prev.length && $(this).index() != 0) {
                            $(prev).val('');
                            $(prev).select();
                        }
                    } else if (
                        (e.keyCode >= 48 && e.keyCode <= 57) ||
                        (e.keyCode >= 96 && e.keyCode <= 105) ||
                        e.keyCode === 39
                    ) {
                        let next = that.find("input").eq($(this).index() + 1);
                        if (next.length) {
                            if (!$(next).val()) {
                                $(next).select();
                            } else {
                                activateNextEmptyField();
                            }
                        } else {
                            that.parents("form")
                                .find('button[type="submit"]')
                                .focus();
                        }
                    }
                    let thisInput = $(this);
                    if (!$(this).val()) {
                        thisInput.removeClass("js-input-active");
                    } else {
                        thisInput.addClass("js-input-active");
                    }
                    activateNextEmptyField();
                    /**code commented because OTP length can be customize */
                    // if (
                    //     otpInput.eq(0).val() &&
                    //     otpInput.eq(1).val() &&
                    //     otpInput.eq(2).val() &&
                    //     otpInput.eq(3).val() &&
                    //     otpInput.eq(4).val()
                    // ) {
                    //     submit.removeClass("ui-disabled");
                    // } else {
                    //     submit.addClass("ui-disabled");
                    // }
                });
            });
    });
}

/**
 * Initialise all form validations
 *
 * @author Nishal K.R <nishal@webandcrafts.com>
 *
 * @return void
 */
function initValidation() {
    page_elements.signup_form.form.validate({
        rules: {
            first_name: {
                required: true,
                maxlength: 25,
                onkeyup: false
            },
            last_name: {
                required: true,
                maxlength: 25,
                onkeyup: false
            },
            country_of_origin: {
                required: true,
                maxlength: 50,
                onkeyup: false
            },
            mobile: {
                required: function(params) {
                    return page_elements.signup_form.email.val() == "";
                },
                digits: true,
                minlength: 6,
                maxlength: 15,
                onkeyup: false
            },
            password: {
                required: true,
                minlength: 8,
                strongPassword: true,
                onkeyup: false
            },
            confirm_password: {
                required: true,
                minlength: 8,
                equalTo: "#register-password",
                onkeyup: false
            },
        },
        messages: {

            password: {
                required: "Please enter a password.",
                minlength: "Password must be at least 8 characters long.",
                strongPassword: "Invalid Password",
                onkeyup: false
            },

            confirm_password: {
                required: "Please confirm your password.",
                minlength: "Password must be at least 8 characters long.",
                equalTo: "Passwords do not match.",
                onkeyup: false
            },
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            if ($(element).attr("name") == "mobile") {
                element
                    .parent()
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            } else {
                element
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            }
        },
        highlight: function(element, errorClass, validClass) {
            if ($(element).attr("name") == "mobile") {
                $(element)
                    .addClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            } else {
                $(element)
                    .addClass("is-invalid")
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            }
        },
        unhighlight: function(element, errorClass, validClass) {
            if ($(element).attr("name") == "mobile") {
                $(element)
                    .removeClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .addClass("hide");
            } else {
                $(element)
                    .removeClass("is-invalid")
                    .siblings(".js-error-msg")
                    .addClass("hide");
            }
        },
    });
    $.validator.addMethod("strongPassword", function(value, element) {
        var hasUppercase = /[A-Z]/.test(value);
        var hasLowercase = /[a-z]/.test(value);
        var hasNumber = /\d/.test(value);
        var hasSymbol = /[@$!%*?&]/.test(value);

        // Set specific error messages for each condition
        this.settings.messages[element.name].strongPassword =
            (!hasUppercase ? "Password must contain at least one uppercase letter." :
                (!hasLowercase ? "Password must contain at least one lowercase letter." :
                    (!hasNumber ? "Password must contain at least one number." :
                        (!hasSymbol ? "Password must contain at least one symbol." : "")
                    )
                )
            );

        // Return true only if all conditions are met
        return hasUppercase && hasLowercase && hasNumber && hasSymbol;
    }, "Invalid password");

    page_elements.verify_otp.form.validate({
        rules: {
            "OTP[]": {
                required: true,
                digits: true,
                minlength: 1,
                maxlength: 1,
                onkeyup: false
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .parents(".js-otp-inputs-wrap")
                .find(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .parents(".js-otp-inputs-wrap")
                .addClass("is-invalid")
                .find(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .parents(".js-otp-inputs-wrap")
                .removeClass("is-invalid")
                .find(".js-error-msg")
                .addClass("hide");
        }
    });

    page_elements.email_form.form.validate({
        rules: {
            email: {
                required: true,
                maxlength: 50,
                onkeyup: false
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .parents(".js-otp-inputs-wrap")
                .find(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .parents(".js-otp-inputs-wrap")
                .addClass("is-invalid")
                .find(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .parents(".js-otp-inputs-wrap")
                .removeClass("is-invalid")
                .find(".js-error-msg")
                .addClass("hide");
        }
    });

    page_elements.login_form.form.validate({
        rules: {
            username: {
                required: true,
                email_or_mobile: true, //check custom method
                onkeyup: false
            },
            country_code: {
                digits: true,
                minlength: 1,
                maxlength: 3,
                onkeyup: false
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .parent()
                .siblings(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .addClass("is-invalid")
                .parent()
                .siblings(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .removeClass("is-invalid")
                .parent()
                .siblings(".js-error-msg")
                .addClass("hide");
        }
    });

    page_elements.login_password_form.form.validate({
        rules: {
            username: {
                required: true
            },
            password: {
                required: true
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .siblings(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .addClass("is-invalid")
                .siblings(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .removeClass("is-invalid")
                .siblings(".js-error-msg")
                .addClass("hide");
        }
    });

    page_elements.fogot_passwod.form.validate({
        rules: {
            username: {
                required: true,
                email_or_mobile: true, //check custom method
                onkeyup: false
            },
            country_code: {
                digits: true,
                minlength: 1,
                maxlength: 3,
                onkeyup: false
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .parent()
                .siblings(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .addClass("is-invalid")
                .parent()
                .siblings(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .removeClass("is-invalid")
                .parent()
                .siblings(".js-error-msg")
                .addClass("hide");
        }
    });

    page_elements.reset_passwod.form.validate({
        rules: {
            password: {
                required: true,
                // minlength: 8,
                onkeyup: false
            },
            confirm_password: {
                required: true,
                // minlength: 8,
                equalTo: "#reset-password",
                onkeyup: false
            }
        },
        errorElement: "span",
        errorPlacement: function(error, element) {
            element
                .siblings(".js-error-msg")
                .html(error.text())
                .removeClass("hide");
        },
        highlight: function(element, errorClass, validClass) {
            $(element)
                .addClass("is-invalid")
                .siblings(".js-error-msg")
                .removeClass("hide");
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element)
                .removeClass("is-invalid")
                .siblings(".js-error-msg")
                .addClass("hide");
        }
    });
}

////////// SignUp /////////////////////////

/**
 * Admin user create
 * @param {JSON} event
 */
function createStudent(event) {
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");
    if(leadSource != null ){
        form_data.append("lead_source", leadSource);
    }

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error, .ui-error-pwd").addClass("hide");
    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                // Add your logic to submit to your backend server here.
                form_data.append("has_otp", true); // generate otp once student added
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successSignUpHandler.bind(this),
                    error: errorSignUpHandler.bind(this)
                });
            });
    });
}
////////// Email Signup /////////////////////////

/**
 * Admin user create
 * @param {JSON} event
 */
function createStudentEmail(event) {
console.log("Email Submit"); 
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error, .ui-error-pwd").addClass("hide");
    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                // Add your logic to submit to your backend server here.
                form_data.append("has_otp", true); // generate otp once student added
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successSignUpHandler.bind(this),
                    error: errorSignUpHandlerEmail.bind(this)
                });
            });
    });
}
/**
 * Success handle for admin user create call
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successSignUpHandler(response) {
    console.log("Sucess :", response);
    if (response.success) {
        response_data = response;
        if(change_number_status == 1){
            changeSlide("whatsapp_otp");
        } 
        proceedToVerification();
        function proceedToVerification() {
            
            if (response.data.source_type) {
                let choosenType = response.data.source_type;
                if(choosenType == 'MOBILE' || choosenType == 'EMAIL') {
                    if (response.data.has_otp) {
                        CommonMethods.setToStorage(
                            page_elements.verify_storage,
                            response.data
                        );
                        let verify_otp = changeSlide("verify_otp"),
                            otp_expier_time = Number(
                                response.data.time,
                                verify_otp.find(".otp-expier")
                            ),
                            otp_expier = (otp_expier_time < 2 ? 2 : otp_expier_time) * 60;
                        if (typeof response.data.otp === "undefined") {
                            OTP_txt = "";
                        } else {
                            OTP_txt = "OTP: " + response.data.otp;
                        }
                        verify_otp
                            .find('input[name="OTP[]"]')
                            .removeAttr("disabled")
                            .end()
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find(".source-type")
                            .text(response.data.source_type == "EMAIL" ? "Email" : "Mobile")
                            .end()
                            .find(".source-value")
                            .text(response.data.source_value)
                            .end()
                            .find(".otp-show")
                            .text(OTP_txt)
                            .end()
                            .find("form")[0]
                            .reset();
                        timer(otp_expier, verify_otp.find(".otp-expier"), function() {
                            verify_otp
                                .find('input[name="OTP[]"]')
                                .attr("disabled", "disabled")
                                .end()
                                .find('button[type="submit"]')
                                .attr("disabled", "disabled")
                                .end()
                                .find(".js-resend-otp-wrap")
                                .removeClass("hide")
                                .end()
                                .find(".otp-expier")
                                .addClass("error")
                                .text("Timeup!");
                        });
                    } else {
                        CommonMethods.alert(
                            "Success",
                            "Account created sucessfully!",
                            "success",
                            {
                                timer: 5000
                            },
                            CommonMethods.redirect.bind($, window.config.route.login)
                        );
                    }
                } else {
                    changeSlide("whatsapp_otp");
                }

                
            } else {
                alert("Please choose a verification type before proceeding.");
            }
        }
    }
}
document.getElementById('chooseWhatsAppButton').addEventListener('click', function() {
    var userName = response_data.data.first_name;
    var whatsappNumber = response_data.data.mobile;

    // Update the content of the HTML elements
    document.getElementById('userName').innerText = userName;
    document.getElementById('whatsAppNumber').innerText = whatsappNumber;
    changeSlide("whatsapp_verification");
});
document.getElementById('changeNumber').addEventListener('click', function() {
    changeNumber();
});
document.getElementById('confirmVerification').addEventListener('click', function() {
    changeSlide("whatsapp_otp");
});
function changeNumber(){
    var studentId = response_data.data.id;
    document.getElementById('studentId').value= studentId;
    document.getElementById('signUp').innerHTML = "Enter your WhatsApp Number";
    var elements = document.getElementsByClassName('formUpdate');
    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
    }
    document.getElementById('numberDiv').classList.remove('col-md-6');
    document.getElementById('numberDiv').style.margin = "auto";
    document.getElementById('numberDiv').style.width = "60%";
    document.getElementById('updateButton').removeAttribute('disabled');
    document.getElementById('register-phone').removeAttribute('readonly');
    document.getElementById('updateButton').style.display = "block";
    change_number_status=1;
    changeSlide("sign_up");
}
document.getElementById('otherOptions').addEventListener('click', function() {
    changeSlide("other_options");
});
document.getElementById('supportTicket').addEventListener('click', function() {
    changeSlide("support_ticket");
});
document.getElementById('detailsUpdate').addEventListener('click', function() {
    document.getElementById('signUp').innerHTML = "Update";
    document.getElementById('signUpLabel').innerHTML = "Update your details";
    document.getElementById('updateButton').removeAttribute('disabled');
    document.getElementById('updateButton').style.display = "block";
    document.getElementById('submitButton').style.display = "none";
    var elements = document.getElementsByClassName('formUpdate');
    for (var i = 0; i < elements.length; i++) {
        elements[i].removeAttribute('readonly');
    }
    document.getElementById('register-phone').removeAttribute('readonly');
    changeSlide("sign_up");
});
/**
 * Error handle for admin user create call
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function errorSignUpHandler(response) {
    if (response.status == 422) {
        // $(".js-common-error")
        //     .text("All inputs are required")
        //     .removeClass("hide");
        $.each(response.responseJSON.errors, function(key, value) {
            console.log(response.responseJSON.errors);
            if (key == "mobile") {
                page_elements.signup_form.form
                    .find('[name="' + key + '"]')
                    .addClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .removeClass("hide")
                    .html(value.join("<br>"));
            } else if (key == "password") {
                page_elements.signup_form.form
                    .find('[name="' + key + '"]')
                    .addClass("is-invalid")
                    .end()
                    .find(".ui-error-pwd")
                    .removeClass("hide")
                    .html(value.join("<br>"));
            } else {
                page_elements.signup_form.form
                    .find('[name="' + key + '"]')
                    .addClass("is-invalid")
                    .siblings(".js-error-msg")
                    .removeClass("hide")
                    .html(value.join("<br>"));
            }
        });
    } else {
        page_elements.signup_form.form
            .find(".js-common-error")
            .text("Something went wrong!!! Please try again")
            .removeClass("hide");
    }
    page_elements.signup_form.form
        .find('button[type="submit"]')
        .removeClass("ui-show-loader")
        .removeAttr("disabled")
        .end()
        .find("input,select")
        .removeAttr("readonly");
}
/**
 * Error handle for admin user create call email
 *
 * @author Arjun <arjun.myieltspartner@gmail.com>
 *
 * @param {JSON} response
 */
function errorSignUpHandlerEmail(response) {
    var emailInput = document.getElementById('register-user-email');
    var errorMsg = document.getElementById('email-error');
    var continueButton = document.querySelector('#register-email-form button[type="submit"]');

    if (response.status == 422) {
        // Validation error
        var errors = response.responseJSON.message;
        // Show the email validation error
        errorMsg.textContent = errors;
        errorMsg.classList.remove('hide');
        // Remove readonly from emailInput
        emailInput.removeAttribute('readonly');

        // Remove class 'xx' from continueButton
        continueButton.classList.remove('ui-show-loader');
        // Disable the continue button
        continueButton.disabled = false;
    } else {
        // Handle other errors here

    }
}

////////// Verify OTP ////////////////

/**
 * Admin user create
 * @param {JSON} event
 */
function verifyOTP(event) {
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action"),
        verify_data = CommonMethods.getFromStorage(
            page_elements.verify_storage
        );
    //  validate the data
    if (!verify_data.source_type && !verify_data.source_value) {
        CommonMethods.alert(
            "Error",
            "Something went wrong!",
            "error",
            {
                timer: 5000
            },
            CommonMethods.redirect.bind($, window.config.login)
        );
    }

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    form_data.append("username", verify_data.source_value);
    form_data.append(
        "country_code",
        verify_data.country_code ? verify_data.country_code : 91
    );
    form_data.append("has_login", verify_data.has_login);
    form_data.append("reset_otp", verify_data.reset_otp);

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successVerifyOTPHandler.bind(this),
                    error: function(response) {
                        $(".otp_input").val("");
                        page_elements.verify_otp.common_error
                            .text(response.responseJSON.message)
                            .removeClass("hide");
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                        if (
                            response.responseJSON.message ==
                            "Attempt Exceeded, resend OTP"
                        ) {
                            $(event.target)
                                .find(".js-resend-otp-wrap")
                                .removeClass("hide");
                            $(".otp-expier").addClass("hide");
                        }
                    }
                });
            });
    });
}

/**
 * Success handle for admin user create call
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successVerifyOTPHandler(response) {
    if (response.success) {
        // page_elements.verify_otp.form[0].reset(); // reset signup form
        if (response.data.has_login == "true") {
            if (redirect_url) {
                console.log("RD Url",redirect_url);
                CommonMethods.redirect(decodeURIComponent(redirect_url));
            } else {
                if(leadSource == "ASAP"){
                    CommonMethods.redirect(window.asapHome);
                } else {
                    CommonMethods.redirect(window.config.route.home);
                }
            }
        } else if (response.data.has_login == "false") {
            let reset_passwod = changeSlide("reset_password");
            reset_passwod.find("form")[0].reset();
        } else {
            CommonMethods.alert(
                "Success",
                "Account created sucessfully!",
                "success",
                {
                    timer: 5000
                },
                CommonMethods.redirect.bind($, window.config.route.login)
            );
        }
    }
}

////////// Resend OTP ////////////////

/**
 * Admin user create
 * @param {JSON} event
 */
function resendOTP(event) {
    event.preventDefault();
    let form_data = new FormData(),
        form_action = $(this).attr("data-action"),
        verify_data = CommonMethods.getFromStorage(
            page_elements.verify_storage
        );

    //  validate the data
    if (!verify_data.source_type && !verify_data.source_value) {
        CommonMethods.alert(
            "Error",
            "Something went wrong!",
            "error",
            {
                timer: 5000
            },
            CommonMethods.redirect.bind($, window.config.login)
        );
    }

    //disable form, submit btn and show loader icon
    $(event.target).attr("disabled", "disabled");
    page_elements.verify_otp.form
        .find(".is-invalid")
        .removeClass("is-invalid")
        .end();
    page_elements.verify_otp.common_error.addClass("hide");

    form_data.append("username", verify_data.source_value);
    form_data.append(
        "country_code",
        verify_data.country_code ? verify_data.country_code : 91
    );
    form_data.append("type", verify_data.source_type);
    form_data.append("has_login", verify_data.has_login);

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successResendOTPHandler.bind(this),
                    error: function(response) {
                        page_elements.verify_otp.common_error
                            .text(response.responseJSON.message)
                            .removeClass("hide");
                    },
                    complete: function() {
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
            });
    });
}

/**
 * Success handle for admin user create call
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successResendOTPHandler(response) {
    if (response.success) {
        clearTimeout(currentTimer);
        CommonMethods.setToStorage(page_elements.verify_storage, response.data);

        let verify_otp = changeSlide("verify_otp"),
            otp_expier_time = Number(
                response.data.time,
                verify_otp.find(".otp-expier")
            ),
            otp_expier = (otp_expier_time < 2 ? 2 : otp_expier_time) * 60;
        if (typeof response.data.otp === "undefined") {
            OTP_txt = "";
        } else {
            OTP_txt = "OTP: " + response.data.otp;
        }
        verify_otp.find(".otp-expier").removeClass("hide");
        verify_otp
            .find('input[name="OTP[]"]')
            .removeAttr("disabled")
            .end()
            .find(".js-resend-otp-wrap")
            .addClass("hide")
            .end()
            .find('button[type="submit"]')
            .removeClass("ui-show-loader")
            .removeAttr("disabled")
            .end()
            .find(".source-type")
            .text(response.data.source_type == "EMAIL" ? "Email" : "Mobile")
            .end()
            .find(".source-value")
            .text(response.data.source_value)
            .end()
            .find(".otp-show")
            .text(OTP_txt)
            .end()
            .find("form")[0]
            .reset();

        verify_otp.find('input[name="OTP[]"]')[0].focus();
        verify_otp.find(".js-resend-otp-wrap").addClass("hide");

        timer(otp_expier, verify_otp.find(".otp-expier"), function() {
            verify_otp
                .find('input[name="OTP[]"]')
                .attr("disabled", "disabled")
                .end()
                .find(".js-resend-otp-wrap")
                .removeClass("hide")
                .end()
                .find('button[type="submit"]')
                .attr("disabled", "disabled")
                .end()
                .find(".js-resend-otp-wrap")
                .removeClass("hide")
                .end()
                .find(".otp-expier")
                .addClass("error")
                .text("Timeup!");
        });
    }
}

////////// Login Check Username ////////////////

function loginUsernameCollect(event) {
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action"),
        username = page_elements.login_form.username.val(),
        coutry_code = $("#login-form")
            .find('input[name="country_code"]')
            .val(),
        mobile_with_country_code = "+" + coutry_code + username;

    $("#login-password-form")
        .find('input[name="country_code"]')
        .val(coutry_code);
    $("#login-password-form")
        .find("#login-password-username")
        .val(mobile_with_country_code);
    countryCodeInput(page_elements.login_password_form.username);

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");
    page_elements.login_form.alert.addClass("hide");

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                // Add your logic to submit to your backend server here.
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: function(resposne) {
                        if (resposne.success) {
                            let login_password = changeSlide("login_password");
                            login_password
                                .find("#login-password-username")
                                .val(username)
                                .keyup();
                            login_password
                                .find("#login-password-password")[0]
                                .focus();
                        }
                    },
                    error: function(response) {
                        if (response.status == 422) {
                            $.each(response.responseJSON.errors, function(
                                key,
                                value
                            ) {
                                page_elements.login_form.form
                                    .find('[name="' + key + '"]')
                                    .addClass("is-invalid")
                                    .parent()
                                    .siblings(".js-error-msg")
                                    .removeClass("hide")
                                    .html(value.join("<br>"));
                            });
                        } else {
                            page_elements.login_form.username
                                .addClass("is-invalid")
                                .parent()
                                .siblings(".js-error-msg")
                                .removeClass("hide")
                                .html(response.responseJSON.message);
                        }
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
            });
    });
}

////////// Login Password ////////////////

function loginPassword(event) {
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action + "?next_url=" + redirect_url,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: function(resposne) {
                        if (resposne.success) {
                            if (redirect_url) {
                                location.href = decodeURIComponent(redirect_url);
                            } else {
                                if(leadSource == "ASAP"){
                                    CommonMethods.redirect(window.asapHome);
                                } else {
                                    CommonMethods.redirect(window.config.route.home);
                                }
                            }
                        }
                    },
                    error: function(response) {
                        if (response.status == 422) {
                            $.each(response.responseJSON.errors, function(
                                key,
                                value
                            ) {
                                $('[name="' + key + '"]')
                                    .addClass("is-invalid")
                                    .siblings(".js-error-msg")
                                    .removeClass("hide")
                                    .html(value.join("<br>"));
                            });
                        } else {
                            page_elements.login_password_form.password
                                .addClass("is-invalid")
                                .siblings(".js-error-msg")
                                .removeClass("hide")
                                .html(response.responseJSON.message);
                        }
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
            });
    });
}

////////// Request OTP ////////////////

function requestOTP(event) {
    event.preventDefault();

    let form_data = new FormData(page_elements.login_password_form.form[0]),
        form_action = $(this).attr("data-action");

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    form_data.append("has_login", true); // enable login after otp

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                // Add your logic to submit to your backend server here.
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successRequestOTPHandler.bind(this),
                    error: function(response) {
                        if (response.status == 422) {
                            $.each(response.responseJSON.errors, function(
                                key,
                                value
                            ) {
                                $('[name="' + key + '"]')
                                    .addClass("is-invalid")
                                    .siblings(".js-error-msg")
                                    .removeClass("hide")
                                    .html(value.join("<br>"));
                            });
                        } else {
                            page_elements.login_password_form.common_error
                                .removeClass("hide")
                                .html(response.responseJSON.message);
                        }
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
            });
    });
}

/**
 * Success handle for request login
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successRequestOTPHandler(response) {
    if (response.success) {
        page_elements.login_password_form.form[0].reset(); // reset login form
        if (response.data.has_otp) {
            CommonMethods.setToStorage(
                page_elements.verify_storage,
                response.data
            );
            let verify_otp = changeSlide("verify_otp"),
                otp_expier_time = Number(
                    response.data.time,
                    verify_otp.find(".otp-expier")
                ),
                otp_expier = (otp_expier_time < 2 ? 2 : otp_expier_time) * 60;

            if (typeof response.data.otp === "undefined") {
                OTP_txt = "";
            } else {
                OTP_txt = "OTP: " + response.data.otp;
            }

            verify_otp
                .find('input[name="OTP[]"]')
                .removeAttr("disabled")
                .end()
                .find('button[type="submit"]')
                .removeClass("ui-show-loader")
                .removeAttr("disabled")
                .end()
                .find(".source-type")
                .text(response.data.source_type == "EMAIL" ? "Email" : "Mobile")
                .end()
                .find(".source-value")
                .text(response.data.source_value)
                .end()
                .find(".otp-show")
                .text(OTP_txt)
                .end()
                .find("form")[0]
                .reset();

            verify_otp.find('input[name="OTP[]"]')[0].focus();

            timer(otp_expier, verify_otp.find(".otp-expier"), function() {
                console.log("Timer call");
                verify_otp
                    .find('input[name="OTP[]"]')
                    .attr("disabled", "disabled")
                    .end()
                    .find('button[type="submit"]')
                    .attr("disabled", "disabled")
                    .end()
                    .find(".js-resend-otp-wrap")
                    .removeClass("hide")
                    .end()
                    .find(".js-resend-otp-wrap")
                    .removeClass("hide")
                    .end()
                    .find(".otp-expier")
                    .addClass("error")
                    .text("Timeup!");
            });
        } else {
            CommonMethods.alert(
                "Success",
                "Account created sucessfully!",
                "success",
                {
                    timer: 5000
                },
                CommonMethods.redirect.bind($, window.config.route.login)
            );
        }
    }
}

////////// Forget Password ////////////////

function initiatePasswordReset(event) {
    event.preventDefault();
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successInitiateResetPasswordHandler.bind(this),
                    error: function(response) {
                        if (response.status == 422) {
                            $.each(response.responseJSON.errors, function(
                                key,
                                value
                            ) {
                                page_elements.fogot_passwod.form
                                    .find('[name="' + key + '"]')
                                    .addClass("is-invalid")
                                    .parent()
                                    .siblings(".js-error-msg")
                                    .removeClass("hide")
                                    .html(value.join("<br>"));
                            });
                        } else {
                            page_elements.fogot_passwod.username
                                .addClass("is-invalid")
                                .parent()
                                .siblings(".js-error-msg")
                                .removeClass("hide")
                                .html(response.responseJSON.message);
                        }
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
                // Add your logic to submit to your backend server here.
            });
    });
}

/**
 * Success handle for reset password initiate
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successInitiateResetPasswordHandler(response) {
    if (response.success) {
        page_elements.fogot_passwod.form[0].reset(); // reset forget password form
        if (response.data.has_otp) {
            let result_data = response.data;
            result_data["reset_otp"] = false;
            CommonMethods.setToStorage(
                page_elements.verify_storage,
                response.data
            );
            if (response.data.otp === undefined) {
                     $(".otp-show")
                    .hide();
            }
            let verify_otp = changeSlide("verify_otp"),
                otp_expier_time = Number(
                    response.data.time,
                    verify_otp.find(".otp-expier")
                ),
                otp_expier = (otp_expier_time < 2 ? 2 : otp_expier_time) * 60;

            if (typeof response.data.otp === "undefined") {
                OTP_txt = "";
            } else {
                OTP_txt = "OTP: " + response.data.otp;
            }

            verify_otp
                .find('input[name="OTP[]"]')
                .removeAttr("disabled")
                .end()
                .find('button[type="submit"]')
                .removeClass("ui-show-loader")
                .removeAttr("disabled")
                .end()
                .find(".source-type")
                .text(response.data.source_type == "EMAIL" ? "Email" : "Mobile")
                .end()
                .find(".source-value")
                .text(response.data.source_value)
                .end()
                .find(".otp-show")
                .text(OTP_txt)
                .end()
                .find("form")[0]
                .reset();
            verify_otp.find('input[name="OTP[]"]')[0].focus();

            timer(otp_expier, verify_otp.find(".otp-expier"), function() {
                verify_otp
                    .find('input[name="OTP[]"]')
                    .attr("disabled", "disabled")
                    .end()
                    .find('button[type="submit"]')
                    .attr("disabled", "disabled")
                    .end()
                    .find(".js-resend-otp-wrap")
                    .removeClass("hide")
                    .end()
                    .find(".otp-expier")
                    .addClass("error")
                    .text("Timeup!");
            });
        }
    }
}

////////// Reset Password ////////////////

function resetPassword(event) {
    event.preventDefault();
    $("#js-common-error-msg").addClass("hide");
    if (!$(this).valid()) {
        return false;
    }
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action"),
        verify_data = CommonMethods.getFromStorage(
            page_elements.verify_storage
        );

    //  validate the data
    if (!verify_data.source_type && !verify_data.source_value) {
        CommonMethods.alert(
            "Error",
            "Something went wrong!",
            "error",
            {
                timer: 5000
            },
            CommonMethods.redirect.bind($, window.config.login)
        );
    }

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    form_data.append("username", verify_data.source_value);
    form_data.append(
        "country_code",
        verify_data.country_code ? verify_data.country_code : 91
    );

    page_elements.verify_otp.otp
        .map(function() {
            form_data.append("OTP[]", $(this).val());
        })
        .get();
    $("#js-common-error-msg").addClass("hide");

    grecaptcha.ready(function() {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function(token) {
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    async: true,
                    success: successResetPasswordHandler.bind(this),
                    error: function(response) {
                        if (response.status == 422) {
                            $.each(response.responseJSON.errors, function(
                                key,
                                value
                            ) {
                                page_elements.reset_passwod.form
                                    .find('[name="' + key + '"]')
                                    .addClass("is-invalid")
                                    .siblings(".js-error-msg")
                                    .removeClass("hide")
                                    .html(value.join("<br>"));
                            });
                        } else {
                            $("#js-common-error-msg")
                                .removeClass("hide")
                                .html(response.responseJSON.message);
                        }
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    }
                });
            });
    });
}

/**
 * Success handle for reset password
 *
 * @author Nishal <nishal@webandcrafts.com>
 *
 * @param {JSON} response
 */
function successResetPasswordHandler(response) {
    if (response.success) {
        page_elements.reset_passwod.form[0].reset(); // reset forget password form

        CommonMethods.removeFromStorage(page_elements.verify_storage);
        let login = changeSlide("login");
        login.find("form")[0].reset();
        page_elements.login_form.alert.removeClass("hide");
    }
}

////////// Common ////////////////

/**
 * Convert input to contry code
 *
 * @param element jsinput - input element
 */
function countryCodeInput(jsinput) {
    let iti = window.intlTelInput(jsinput[0], {
        separateDialCode: true,
        utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js",
        initialCountry: "auto",
        geoIpLookup: function(callback) {
            $.get("https://ipinfo.io", function() {}, "jsonp").always(function(
                resp
            ) {
                var countryCode = resp && resp.country ? resp.country : "in";
                callback(countryCode);
            });
        }
    });

    let country_input = jsinput.parents("form").find(".js-country-code input");

    // listen to the telephone input for changes
    jsinput.on("countrychange", function(e) {
        country_input.val(iti.getSelectedCountryData().dialCode);
    });
}

function changeSlide(type) {
    let slides = {
        login: ".js-login",
        login_password: ".js-password-login",
        login_otp: ".js-request-otp",
        forget_password: ".js-forgot-password",
        sign_up: ".js-sign-up",
        no_change: ".js-number-change",
        choose_type: ".js-choose-type",
        whatsapp_verification: ".js-whatsapp-verification",
        whatsapp_otp: ".js-whatsapp-otp",
        other_options: ".js-other-options",
        support_ticket: ".js-support-ticket",
        verify_otp: ".js-verify-otp",
        reset_password: ".js-reset-password"
    };
    $(".js-sec.ui-show").removeClass("ui-show");
    $(".js-sec" + slides[type]).addClass("ui-show");
    return $(".js-sec" + slides[type]);
}

/**
 * Timer
 */
let currentTimer;

function timer(remaining, element, callback) {
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    element.text(m + ":" + s);
    remaining -= 1;
    if (currentTimer) {
        clearTimeout(currentTimer); // Clear the previous timer
    }
    if (remaining >= 0 && timerOn) {
        currentTimer = setTimeout(function() {
            timer(remaining, element, callback);
        }, 1000);
        return;
    }

    if (!timerOn) {
        // Do validate stuff here
        return;
    }

    // Do timeout stuff here
    callback();
}

$("#verify-otp .js-otp-inputs-wrap input").bind("paste", function(e) {
    activateNextEmptyField();
});

function activateNextEmptyField() {
    var is_focus = true;
    $('#verify-otp button[type="submit"]').addClass("ui-disabled");
    $.each($('input[name="OTP[]"]'), function(input_key, input_element) {
        if (!$(input_element).val()) {
            $(input_element).focus();
            is_focus = false;
            return false;
        }
    });
    if (is_focus) {
        $('#verify-otp button[type="submit"]')
            .removeClass("ui-disabled")
            .focus();
    }
}
